export function getMaxPlanLevelFromSubscriptions(subscriptions, agreementID){
    return Math.max(subscriptions
        .filter(subscription => subscription.plan.agreement.id === agreementID)
        .map(subscription => parseInt(subscription.plan.level)))
}